export const stats: readonly (readonly [string, string])[] = [
  ['+2.400', 'personas aplicando el protocolo'],
  ['5', 'Volúmenes completos'],
  ['5', 'Bonos incluidos'],
  ['4.9/5', 'calificación'],
]

export const testimonials: readonly (readonly [string, string, string, string])[] = [
  ['MC', 'Mariana C.', 'Buenos Aires', 'A los 12 días dejé de hincharme después de cada comida.'],
  ['LP', 'Lucía P.', 'Córdoba', 'Descubrí que el problema no era “comer mal”, era el orden de mis comidas.'],
  ['SR', 'Sofía R.', 'Rosario', 'Llegué a la gastroenteróloga con todo registrado y cambió por completo la consulta.'],
]

export const extendedTestimonials: readonly (readonly [string, string, string])[] = [
  ['Mariana C.', 'Buenos Aires', '“Llevaba 4 años con distensión todos los días. En dos semanas volví a usar mi ropa de siempre y a salir a comer sin miedo.”'],
  ['Lucía P.', 'Córdoba', '“El diario de síntomas me mostró que los lácteos y el ayuno largo eran mis peores gatillos. Nadie me lo había explicado así.”'],
  ['Sofía R.', 'Rosario', '“Probé de todo por mi cuenta durante años. Tener las 3 fases ordenadas fue lo que finalmente me sacó del círculo de recaídas.”'],
  ['Claudia M.', 'Mendoza', '“Soy nutricionista y lo compré con escepticismo. El nivel de detalle de la reintroducción es mejor que muchos materiales profesionales.”'],
]

export const painPoints: readonly string[] = [
  'Te levantás con el abdomen plano y a media tarde parecés de seis meses de embarazo.',
  'Gases, eructos y ruidos que aparecen justo cuando estás con gente.',
  'Alternás entre días de estreñimiento y días en los que no podés alejarte del baño.',
  'Ya eliminaste gluten, lácteos y azúcar, y seguís igual o peor.',
  'Te dijeron que “es colon irritable, es estrés” y te fuiste sin un plan concreto.',
  'Gastaste en suplementos y probióticos sueltos que nunca terminaron de funcionar.',
]

export const volumes: readonly (readonly [string, readonly string[], string])[] = [
  [
    'Volumen 1 — Entender el SIBO',
    [
      'Entendés qué está pasando realmente en tu intestino delgado',
      'Diferenciás SIBO, IMO y colon irritable sin confundir síntomas',
      'Identificás cuál de los 3 tipos explica mejor tu cuadro',
      'Arrancás con dirección clara desde el Día 1',
    ],
    'border-blue-400/30',
  ],
  [
    'Volumen 2 — Fase 1: Bajar la carga',
    [
      'Reducís hinchazón y gases con un plan de 14 días paso a paso',
      'Sabés qué comer en cada comida, sin contar nada',
      'Ordenás horarios y espacios entre comidas para frenar la fermentación',
      'Cortás el círculo de recaídas antes de tocar suplementos',
    ],
    'border-green-400/30',
  ],
  [
    'Volumen 3 — Fase 2: Limpiar y reparar',
    [
      'Conocés los antimicrobianos naturales más estudiados y cómo se combinan',
      'Aprendés a manejar el efecto de la desintoxicación sin abandonar',
      'Reparás la mucosa intestinal con nutrientes concretos',
      'Seguís un cronograma de 4 semanas ya armado',
    ],
    'border-amber-400/30',
  ],
  [
    'Volumen 4 — Fase 3: Reintroducir sin recaer',
    [
      'Reincorporás alimentos en el orden correcto, de a uno',
      'Detectás tus gatillos reales en lugar de eliminar para siempre',
      'Recuperás vida social, restaurantes y comidas en familia',
      'Sabés exactamente qué hacer si aparece una recaída',
    ],
    'border-red-400/30',
  ],
  [
    'Volumen 5 — Prevención y motilidad',
    [
      'Activás el complejo motor migratorio, la clave de la recurrencia',
      'Ordenás sueño, estrés y movimiento para sostener el resultado',
      'Usás un checklist mensual de mantenimiento',
      'Tenés un plan de sostenibilidad para no volver al punto de partida',
    ],
    'border-yellow-400/30',
  ],
]

export const includes: readonly string[] = [
  'Plan diario listo para arrancar hoy',
  'Cronograma completo de las 3 fases',
  'Guía de registro para conversar con tu médico',
  'Checklists imprimibles por etapa',
]

export const bonuses: readonly (readonly [string, string, readonly string[], string])[] = [
  ['01', 'Diario de Síntomas 21 Días', ['Detectás en 3 semanas qué alimentos disparan tu hinchazón', 'Registrás digestión, sueño y estrés en 2 minutos por día', 'Llevás datos claros a cada consulta médica'], '$12.000'],
  ['02', 'Recetario Bajo en Fermentables', ['50 recetas con ingredientes de cualquier supermercado', 'Desayunos, almuerzos y cenas ya resueltos', 'Lista de compras semanal lista para imprimir'], '$14.000'],
  ['03', 'Guía de Suplementos', ['Sabés qué se usa en cada fase y en qué orden', 'Evitás combinaciones que empeoran los síntomas', 'Entendés dosis y tiempos para conversar con tu profesional'], '$10.000'],
  ['04', 'Protocolo Anti-Recaída', ['Reconocés las señales tempranas de una recaída', 'Aplicás un reset de 72 horas cuando te desviás', 'Volvés al plan sin empezar todo de cero'], '$11.000'],
  ['05', 'Eje Intestino-Cerebro', ['Bajás el estrés que mantiene tu digestión frenada', 'Aplicás una rutina de 10 minutos antes de comer', 'Mejorás el descanso para acelerar la reparación'], '$9.000'],
]

export const faqs: readonly (readonly [string, string])[] = [
  ['¿Necesito un test de SIBO para empezar?', 'No. Es un material educativo e informativo que podés aplicar con o sin test. Complementa el tratamiento indicado por tu médico; no lo reemplaza.'],
  ['¿Los ingredientes son caros o difíciles de conseguir?', 'No. El sistema prioriza alimentos que encontrás en cualquier supermercado y dietética de Argentina.'],
  ['¿Cuándo empiezo a notar cambios?', 'La mayoría nota menos hinchazón y gases entre el día 10 y el día 21 de aplicación constante de la Fase 1.'],
  ['¿Sirve si ya probé dieta baja en FODMAP?', 'Sí. La mayoría falla en la reintroducción y en la motilidad, que son justamente los Volúmenes 4 y 5 del protocolo.'],
  ['¿La garantía es real?', 'Sí. Si en 30 días no es lo que esperabas, escribís a soportebiomalivido@gmail.com y te devolvemos el 100%. Sin preguntas.'],
  ['¿Es 100% digital?', 'Sí. Acceso inmediato en PDF, más de 300 páginas. Lo leés desde el celular, tablet o computadora, e imprimís lo que quieras.'],
]

export const costs: readonly string[] = [
  'Otro año planificando tu día alrededor del baño',
  'Seguir eliminando alimentos hasta quedarte sin opciones',
  'Consultas que terminan siempre en “es estrés, relajate”',
  'Gastar en probióticos sueltos que no cambian nada',
  'Otro año sin mapa, sin fases y sin dirección',
]

export const purchases: readonly (readonly [string, string])[] = [
  ['Mariana C.', 'Buenos Aires'],
  ['Lucía P.', 'Córdoba'],
  ['Sofía R.', 'Rosario'],
  ['Claudia M.', 'Mendoza'],
]
